import React from 'react';
import propTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { TriangleAlert } from 'lucide-react';
import Modal from 'tailwind-components/Modal/Modal';
import Button from 'tailwind-components/Button/Button';
import { setIncludeInactiveAgentsInReport } from 'state/actions/actions';

function ExportConfirmedAppointmentsModal({
  open,
  onClose,
  agencies,
  onConfirm,
  loading,
  showUnappliedWarning
}) {
  const dispatch = useDispatch();
  const includeInactive = useSelector(
    state => state.agencyManagement.includeInactiveAgentsInReport
  );

  const count = agencies.length;
  const label = count === 1 ? 'agency' : 'agencies';

  const footer = (
    <div className='flex w-full items-center justify-end gap-3'>
      <Button
        variant='secondary'
        size='small'
        text='Cancel'
        onClick={onClose}
        isDisabled={loading}
      />
      <Button
        variant='primary'
        size='small'
        text='Export'
        onClick={() => onConfirm(includeInactive)}
        isLoading={loading}
        isDisabled={loading}
      />
    </div>
  );

  return (
    <Modal
      active={open}
      closeModal={onClose}
      size='small'
      title='Export Confirmed Appointments'
      footer={footer}
    >
      <div className='flex flex-col gap-4'>
        <p className='m-0 text-sm text-grey-dark'>
          This report will cover{' '}
          <span className='font-semibold'>
            {count} {label}
          </span>
          .
        </p>
        {showUnappliedWarning && (
          <p className='m-0 flex items-center gap-1.5 text-xs text-amber-600'>
            <TriangleAlert className='size-3.5 shrink-0' />
            You have unapplied changes in your agency selection — this export
            will only include the agencies applied the last time the data was
            loaded.
          </p>
        )}
        <FormControlLabel
          control={
            <Checkbox
              checked={includeInactive}
              onChange={e =>
                dispatch(setIncludeInactiveAgentsInReport(e.target.checked))
              }
              size='small'
            />
          }
          label={
            <span className='text-sm text-grey-dark'>
              Include inactive agents in report
            </span>
          }
        />
      </div>
    </Modal>
  );
}

ExportConfirmedAppointmentsModal.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  agencies: propTypes.arrayOf(
    propTypes.shape({
      agencyId: propTypes.string.isRequired,
      agencyName: propTypes.string.isRequired
    })
  ).isRequired,
  onConfirm: propTypes.func.isRequired,
  loading: propTypes.bool,
  showUnappliedWarning: propTypes.bool
};

export default ExportConfirmedAppointmentsModal;
